import { IconsProps } from '@/types/shared'
import React from 'react'

const AnalyticsDownIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
            >
                <path
                    d="M20.6 6L22 7.4L14.6 14.85L10.6 10.85L5.4 16H8V18H2V12H4V14.6L10.6 8L14.6 12L20.6 6Z"
                    fill={props?.color || '#CE1721'}
                />
            </svg>
        </div>
    )
}

export default AnalyticsDownIcons
